import React from 'react';
import Header from '../components/Dashboard/Header';
import WaterfallChart from '../components/Dashboard/WaterfallChart';
import TrendsChart from '../components/Dashboard/TrendsChart';
import CountrySpendingAnalysis from '../components/Dashboard/CountrySpendingAnalysis';
import SalesSpendCorrelation from '../components/Dashboard/SalesSpendCorrelation';
import GeoChannelAnalysis from '../components/Dashboard/GeoChannelAnalysis';
import AIInsightsChatbot from '../components/Dashboard/AIInsightsChatbot';

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <Header />
        
        {/* Executive KPIs & Core Analytics */}
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 mb-8">
          <CountrySpendingAnalysis />
          <SalesSpendCorrelation />
        </div>
        
        {/* Budget Analysis */}
        <div className="mb-8">
          <WaterfallChart />
        </div>
        
        {/* Media Mix & Geographic Analysis Combined */}
        <div className="mb-8">
          <GeoChannelAnalysis />
        </div>
        
        {/* Performance Trends */}
        <div className="mb-8">
          <TrendsChart />
        </div>
        
        <footer className="text-center py-6 border-t border-blue-100">
          <p className="text-sm text-gray-600">
            Media Mix Modelling Dashboard • Real-time insights for data-driven decisions
          </p>
          <p className="text-xs text-gray-500 mt-1">
            Executive Summary Dashboard • Last updated: {new Date().toLocaleDateString()}
          </p>
        </footer>
      </div>
      
      {/* AI Insights Chatbot */}
      <AIInsightsChatbot />
    </div>
  );
};

export default Dashboard;